export default "__VITE_ASSET__DibvsAPV__"